import { render, staticRenderFns } from "./StockFavoriteView.vue?vue&type=template&id=d58eab58&scoped=true"
import script from "./StockFavoriteView.vue?vue&type=script&lang=js"
export * from "./StockFavoriteView.vue?vue&type=script&lang=js"
import style0 from "./StockFavoriteView.vue?vue&type=style&index=0&id=d58eab58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d58eab58",
  null
  
)

export default component.exports